import { Card, CardTitle, CardHeader, CardContent } from "@/components/ui/card";
import { Plus, CheckCircle2, XCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useNavigate } from "react-router-dom";

interface PricingModel {
    id: string;
    name: string;
    active: boolean;
    description?: string;
    createdAt: string;
    productCount?: number;
}

function PricingModelsPage() {
    const navigate = useNavigate();

    // Mock data for pricing models
    const pricingModels: PricingModel[] = [
        {
            id: "1",
            name: "Wood Sheds",
            active: true,
            createdAt: "2024-01-15",
            productCount: 42,
        },
        {
            id: "2",
            name: "Plastic Garden Furniture",
            active: true,
            createdAt: "2024-02-10",
            productCount: 18,
        },
        {
            id: "3",
            name: "Fencing",
            active: false,
            createdAt: "2024-01-20",
            productCount: 0,
        },
        {
            id: "4",
            name: "Summer Houses",
            active: true,
            createdAt: "2024-03-05",
            productCount: 7,
        },
    ];

    const handleCreateNew = () => {
        // TODO: Implement create new pricing model
        console.log("Create new pricing model");
    };

    return (
        <div className="w-full space-y-6">
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                {pricingModels.map((model) => (
                    <Card
                        key={model.id}
                        className="cursor-pointer transition-colors hover:bg-muted/50"
                        onClick={() => navigate(`/pricing-models/${model.id}`)}
                    >
                        <CardHeader>
                            <div className="flex items-start justify-between">
                                <CardTitle className="text-lg">
                                    {model.name}
                                </CardTitle>
                                {model.active ? (
                                    <Badge variant="default" className="ml-2">
                                        <CheckCircle2 className="h-3 w-3 mr-1" />
                                        Active
                                    </Badge>
                                ) : (
                                    <Badge variant="secondary" className="ml-2">
                                        <XCircle className="h-3 w-3 mr-1" />
                                        Inactive
                                    </Badge>
                                )}
                            </div>
                        </CardHeader>
                        <CardContent>
                            <div className="space-y-2 text-sm text-muted-foreground">
                                {model.productCount !== undefined && (
                                    <div>
                                        <span className="font-medium">
                                            Products:
                                        </span>{" "}
                                        {model.productCount}
                                    </div>
                                )}
                                <div>
                                    <span className="font-medium">
                                        Created:
                                    </span>{" "}
                                    {new Date(
                                        model.createdAt
                                    ).toLocaleDateString()}
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                ))}
                <Card
                    className="cursor-pointer transition-colors hover:bg-muted/50 border-dashed flex flex-col"
                    onClick={handleCreateNew}
                >
                    <CardContent className="flex items-center justify-center flex-1 py-6">
                        <div className="flex flex-col items-center gap-2 text-muted-foreground">
                            <Plus className="h-8 w-8" />
                            <span className="text-sm font-medium">
                                New Pricing Model
                            </span>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}

export default PricingModelsPage;
